import React from "react";
import Image from "next/image"
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// core components
import ScriptEmbed from '/tribalism-component/script-embed.js';

import { relative } from "path";
import styles from "../../../../services/ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">

      <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          
        <h3 className={classes.title}>Update February 2022- Data Engineering, Big Data, and Machine Learning on GCP Specialization Review</h3>
        <br />
        <p>
          <strong>Has this cource been updated?</strong> Sort of ... it is now called Data Engineering, Big Data, and Machine Learning on GCP Specialization
          <br />
          <strong>What is the price of this?</strong> Back in 2017 this was: $AUD425 ~= $US350. Now pricing has changed to a subscription model of $69 per month, where you get access to "all of coursera". If you just want to sit one course - you can do it "quickly" and then cancel your subscription to save money.
          <br />
          <strong>How different is this to previous:</strong>
          <br /><br />
        </p>
        <div style={{position: 'relative', maxWidth: '100%', overflowX: 'scroll', overflowY: 'hidden'}}>
        <table style={{fontSize: '1.188rem'}}>
          <thead>
            <tr>
              <th>New Course</th>
              <th>Old Course</th>
              <th>Difference</th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td>Google Cloud Big Data and Machine Learning Fundamentals</td>
            <td>Google Cloud Platform Big Data and Machine Learning Fundamentals</td>
            <td>Same</td>
          </tr>
          <tr>
            <td>Modernizing Data Lakes and Data Warehouses with Google Cloud</td>
            <td>Leveraging Unstructured Data with Cloud Dataproc on Google Cloud Platform</td>
            <td>Minimal</td>
          </tr>
          <tr>
            <td>Building Batch Data Pipelines on GCP</td>
            <td>Serverless Data Analysis with Google BigQuery and Cloud Dataflow</td>
            <td>Minimal</td>
          </tr>
          <tr>
            <td>Smart Analytics, Machine Learning, and AI on GCP</td>
            <td>Serverless Machine Learning with Tensorflow on Google Cloud Platform</td>
            <td>Minimal</td>
          </tr>
          <tr>
            <td>Building Resilient Streaming Analytics Systems on Google Cloud</td>
            <td>Building Resilient Streaming Systems on Google Cloud Platform</td>
            <td>Minimal</td>
          </tr>
          </tbody>
        </table>
        </div>
          <h3 className={classes.title}>Summary February 2022:</h3>
          <p>The adivce is the same as before - the machine learning bits at the end are the best. However Google has advanced even further in terms of data pipelines and stremaing - so theres lots of good stuff here too!
            <br /><br />
            ------------------------------------------------
          </p>

        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Review: I completed Data Engineering on Google Cloud Platform Specialization (Coursera)</h3>
          <br />
          <p>
            Recently I completed the Data Engineering on Google Cloud Platform Specialization <a href="https://www.coursera.org/specializations/gcp-data-machine-learning">link here</a> through Coursera, here is my review.
          </p>

        </GridItem>
        
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Summary Review:</h3>
          <p>
          It’s good, reasonably advanced, has plenty of code examples and I recommend it for anyone working on the GCP. Only problem was a couple of issues in the final labs of the course.
          </p>
          </GridItem>

          <GridItem xs={12} sm={8} md={8}>
            <h3 className={classes.title}>Detailed Review</h3>
            <p style={{marginBottom: 0}}>
              The course is divided into 5 modules of increasing complexity:
            </p>
            <Box sx={{'& ol':{mt: 0, mb: 2}, '& li': {fontSize: '1.188rem', my: 1 }}}>
              <ol start="1">
                <li>Google Cloud Platform Big Data and Machine Learning Fundamentals</li>
                <li>Leveraging Unstructured Data with Cloud Dataproc on Google Cloud Platform</li>
                <li>Serverless Data Analysis with Google BigQuery and Cloud Dataflow</li>
                <li>Serverless Machine Learning with Tensorflow on Google Cloud Platform</li>
                <li>Building Resilient Streaming Systems on Google Cloud Platform</li>
                <li>You can take each module out of order or complete sequentially. Its up to you, I’d recommend to keep it sequential at least roughly. I went from 1 to 3 then went back to 2, 4 and then 5.</li>
              </ol>
            </Box>
            <p>
              The courses are hosted by Valliappa Lakshmanan from Google. He does a pretty great job overall. Modules are shaped initially with slides and discussion, followed by Labs run through Google Codelabs (https://codelabs.developers.google.com/) which is a free to use training platform for hands-on labs in the Google Cloud Platform – highly, highly recommended!
              <br /><br />
              Each Module is slated to take between 6-8 hours to complete. I found this to be roughly correct, although closer to 8 hours, especially on the latter modules were the lab content really ramps up and you run into inevitable code issues (Google pub/sub version 0.27.0 Im looking at you!) which mean the labs take longer as you google for explanations…
              <br /><br />
              Whilst I did complete 2 of the modules in one day (not recommended), they really are chock full of content, so Id make sure to leave adequate time. If you had time of work, Id say 5 in 5 days is doable, although still fairly chock full.
              <br /><br />
              The labs were great with all of the code saved in Github for you to use. No complaints here, they all worked really well and fit into the rest of the course material nicely.
              <br /><br />
            </p>
            <h4 className={classes.title}>THERE ARE QUIZZES..</h4>
            <p>
              There are also a number of short Quizzes throughout (roughly 5 per module with 2 or 3 questions in each). They can be tricky and you get 3 attempts in any 8 hour period in case you don’t pass the first time. Funnily enough I didn’t pass the very first quiz… on second attempt I did and from then on I made sure not to repeat the first up miss for the rest of the course (which I didn’t :-))
              <br /><br />
            </p>
            <h4 className={classes.title}>THE MACHINE LEARNING BIT IS THE BEST!</h4>
            <p>
              My favourite part of the course was Serverless Machine Learning with Tensorflow on Google Cloud Platform. What a cool concept Tensorflow and its associated pals: Dataflow, Cloud ML and GCS are. It really seems like the entire google cloud has been set up to handle massive, at scale machine learning. The task is complicated – shifting out: data cleaning, feature transformations, hyperparameter training and data ingestion across myriads of machines on the GCP network.
              <br /><br />
              Certainly the process has been greatly simplified with tools like Dataflow in particular, but the fact remains: Machine Learning (at scale/real-time etc) is large and complex undertaking. Users should consider taking at least a couple of weeks to formulate a proper data structure and model. Like many others have said, building the actual model is only a small percentage of the work – getting the data, cleaning it and (as the course shows) understanding it – will take up the bulk of your time.
              <br /><br />
              The Tensorflow module focuses on building a ML Neural Network model that collates New York traffic data and attempts to estimate fares for taxi users given starting and ending locations. Variables such as time of day, day of week, euclidean distance etc are included in the model. What was most interesting to me – was how one of the biggest improvements in RMSE was at the end when the full data set was used – more data = more accurate model… interesting.
            </p>
          </GridItem>

          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Minor Concerns with the Course:</h3>
          <p>
          <a href="https://twitter.com/lak_gcp">Valliappa Lakshmanan</a> contacted me on twitter re these issues – see below:
          </p>
          </GridItem>


          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
            <blockquote className="twitter-tweet">
              <p lang="en" dir="ltr">
                Thanks for the review! The pubsub issue has been fixed in GitHub, so if you update, you&#39;ll get fix. Quota issue for last lab is difficult -- that level of free resources invites Bitcoin miners ...
              </p>
              &mdash; Lαк Lαкѕнмαηαη (@lak_gcp) 
              <a href="https://twitter.com/lak_gcp/status/932994833328652289?ref_src=twsrc%5Etfw">
                November 21, 2017
              </a>
            </blockquote>
            <ScriptEmbed
              src='https://platform.twitter.com/widgets.js'
              scriptId='twitter-embedded'
              charSet='utf-8'
            />
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>

            <br />
            Thanks so much for responding Valliappa!! I will leave the original comments below here for a little while just in case someone else comes across a related issue and it might be helpful.
            <br /><br />
            A couple of concerns I had with the course occurred in the final module on Building Resilient Streaming Systems on Google Cloud Platform. The final few labs used a simulated streaming model through Google Pub/Sub that didn’t work on my Cloud Shell. The reason being as stated above was the version conflicts in Pub/Sub. The code in the lab relies on version 0.27.0 of Pub/Sub to work. To get around this issue follow the steps here: <a href="https://github.com/GoogleCloudPlatform/training-data-analyst/tree/master/courses/streaming/publish" style={{wordWrap: 'break-word'}}>https://github.com/GoogleCloudPlatform/training-data-analyst/tree/master/courses/streaming/publish</a>
            <br /><br />
            The other issue I had (which was unfortunately quite annoying) was that because I am on the free GCP trial I didn’t have enough “quota” to run the final lab. See below:
            </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"800px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <Image
                      layout = "responsive"
                      width = {770}
                      height= {295}
                      src="/img/posts/2017-11-20-data-engineering-on-gcp-specialization-coursera-review/2-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    
            </GridItem>
          </div>


          <GridItem xs={12} sm={8} md={8}>

          <p>
          <br /><br />
          This is despite having over $300 credit still in my free trial as you can see above. From what I can tell there is an arbitrary quota limit that sits outside the $ figure stated in your trial. This is actually disappointing and I think Google should be more clear upfront to users about these quotas. Free data/resources is awesome! But facing the reality that your actual testing of the platform for some use cases can only occur on paid accounts is not. It is testing after all!
          <br /><br />

          The courses are hosted by Valliappa Lakshmanan from Google. He does a pretty great job overall. Modules are shaped initially with slides and discussion, followed by Labs run through Google Codelabs <span style={{wordWrap:'break-word'}}>(https://codelabs.developers.google.com/)</span> which is a free to use training platform for hands-on labs in the Google Cloud Platform – highly, highly recommended!
          <br /><br />
          
          </p>

          <h4 className={classes.title}>OVERALL COMMENTS:</h4>

          <p>
          Despite the teething issues in the last module, overall I liked this course quite a bit and I’m really interested in getting Valliappa’s book now which is to be released on November 25th <a href="https://books.google.com.au/books/about/Data_Science_on_the_Google_Cloud_Platfor.html?id=MgAaMQAACAAJ&amp;redir_esc=y!">Link to Book Details</a>
          <br /><br />
          Thanks for Reading!
          <br /><br />
          
          </p>

          </GridItem>

          

      </GridContainer>
    </div>

  );
}
